import { render, staticRenderFns } from "./SL410.vue?vue&type=template&id=0b7a18d8&scoped=true&"
import script from "./SL410.vue?vue&type=script&lang=js&"
export * from "./SL410.vue?vue&type=script&lang=js&"
import style0 from "./SL410.vue?vue&type=style&index=0&id=0b7a18d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a18d8",
  null
  
)

export default component.exports